/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//fix trustpilot location on desktop

var CurrentOnDesktop = true;
var previousParent = null;
var TrustPilotWidget = null;
var FoundTrustPilot = false;

GetTrustPilotWidget();
function GetTrustPilotWidget(){
    TrustPilotWidget = (TrustPilotWidget == null) ? document.querySelector("header #trustpilot-widget-trustbox-1-wrapper") : TrustPilotWidget;
    if(TrustPilotWidget){
        previousParent = (previousParent == null) ? TrustPilotWidget.parentElement : previousParent;
        var CompleteElementTest = TrustPilotWidget.querySelector(".trustpilot-widget");
        if(CompleteElementTest){
            FoundTrustPilot = true;
            if(window.innerWidth < 1000){
                CurrentOnDesktop = false;
                SetTrustPilotMobile();
            }else{
                CurrentOnDesktop = true;
                SetTrustPilotDesktop();
            }
            
        }else{
            setTimeout(() => {GetTrustPilotWidget()}, 250);
        }
    }else{
        TrustPilotWidget = (TrustPilotWidget == null) ? document.querySelector("header #trustpilot-widget-trustbox-2-wrapper") : TrustPilotWidget;
        setTimeout(() => {GetTrustPilotWidget()}, 250);
    }
}

function SetTrustPilotDesktop(){
    if(!FoundTrustPilot)
        return;
    var ParentNode = document.querySelector(".nav-bar.small .container");
    if(ParentNode && TrustPilotWidget){
        ParentNode.appendChild(TrustPilotWidget);
        CurrentOnDesktop = true;
    }
}
function SetTrustPilotMobile(){
    if(!FoundTrustPilot)
        return;
    previousParent.insertBefore(TrustPilotWidget, previousParent.firstChild);
    CurrentOnDesktop = false;
}

window.onresize = CheckTrustpilotWidget;
function CheckTrustpilotWidget(){
    if(!FoundTrustPilot)
        return;
    if(window.innerWidth < 1000 && CurrentOnDesktop){
        SetTrustPilotMobile();
    }else if(window.innerWidth >= 1000 && !CurrentOnDesktop){
        SetTrustPilotDesktop();
    }
};
